<router>
{
    name: 'Models'
}
</router>

<template lang="pug">
.analytics__models
    v-container(width="100%" fluid)
        v-card(light)
            v-card-text
                v-row
                    v-col(cols='auto')
                        v-select(
                            label="Select customer"
                            :items="customers"
                            v-model="selectedCustomer"
                            :item-text="customerCompositeLabel"
                            item-value="id"
                            color="brand"
                        )
                    v-col(cols='auto')
                        v-select(
                            label="Select system"
                            :items="filteredSystems"
                            v-model="selectedSystem"
                            :item-text="systemCompositeLabel"
                            item-value="id"
                            :disabled="!selectedCustomer"
                            color="brand"
                        )
                    v-col(cols='auto')
                        template(v-if="isRefreshing")
                            v-progress-circular(
                                size="24"
                                width="2"
                                color="brand"
                                indeterminate
                                class="ml-2 mt-2"
                            )
                v-row
                    v-col
                        template(v-if="filteredModelInfoList.length === 0")
                            div.text-grey.text-center.py-6 No models found for this system.
                        template(v-else)
                            v-expansion-panels(accordion :model-value="[]" focusable)
                                v-expansion-panel(v-for="m in filteredModelInfoList" :key="m.id")
                                    v-expansion-panel-header
                                        .d-flex.justify-space-between.align-center.w-100
                                            .text-left(style="width: 30%") {{ formatDate(m.createdAt) }}
                                            .text-center(style="width: 40%") {{ m.model_version }}
                                            .text-right(style="width: 30%")
                                                v-chip.ml-2(v-if="m.is_active" color="green" small) Active
                                    v-expansion-panel-content
                                        ModelInfo(
                                            :model="m",
                                            :timezone="currentSystemTimezone"
                                        )
</template>

<script>
import { DateTime } from 'luxon';
import ModelInfo from '@/components/analytics/modelInfo.vue';
export default {
    name: 'Models',
    components: {
        ModelInfo,
    },
    data () {
        return {
            // component data
            customers: [],
            systems: [],
            modelInfoList: [],
            selectedSystem: null,
            selectedCustomer: null,
            refreshStartDate: DateTime.now().minus({ days: 1 }).toISODate(),
            lastRefreshed: DateTime.now().toFormat('MM/dd hh:mm:ss a ZZZZ'),
            isRefreshing: false,
        };
    },
    methods: {
        getData () {
            this.isRefreshing = true;
            console.log('fetching data');
            this.socketEmit('getModelsCustomersSystems', {}, (response) => {
                try {
                    const { customers, error } = response || {};
                    if(error) {
                        this.$set(this, 'error', error);
                        console.error('Error fetching models data:', error);
                    } else {
                        console.log('Fetched models data successfully');
                        this.$set(this, 'customers', customers || []);
                        if (this.customers.length > 0) {
                            this.selectedCustomer = this.customers[0].id;
                            if (this.filteredSystems.length > 0) {
                                this.selectedSystem = this.filteredSystems[0].id;
                            }
                        }
                    }
                } catch (e) {
                    console.error('Error processing models data:', e);
                } finally {
                    this.isRefreshing = false;
                }
            });
        },

        /**
         *
         * @param {string} date - ISO timestamp
         */
        formatDate (date) {
            // the date is going to have the wrong offset because it is in UTC even though Sequelize thinks it is in the server timezone
            if (!date) return 'N/A';
            let dt = DateTime.fromFormat(date.replace('T', ' ').replace(/Z|[+-]\d{2}:?\d{2}$/, ''), "yyyy-MM-dd HH:mm:ss.SSS", { zone: 'UTC' });
            if (!dt.isValid) {
                // fallback: try parsing as ISO, then force to UTC
                dt = DateTime.fromISO(date, { zone: 'utc' });
            }
            console.log('browserTimezone:', this.browserTimezone);
            dt = dt.setZone(this.browserTimezone);
            return dt.isValid ? dt.toFormat('MM/dd hh:mm a ZZZZ') : 'Invalid date';
        }
    },
    computed: {
        filteredSystems () {
            if (!this.selectedCustomer) return [];
            const foundCustomer = this.customers.find(c => c.id === this.selectedCustomer);
            return foundCustomer?.systems || [];
        },
        customerCompositeLabel () {
            return item => `${item.name} [ ${item.state} ]`;
        },
        systemCompositeLabel () {
            return item => `${item.system_name} (${item.id})`;
        },
        filteredModelInfoList () {
            if (!this.selectedCustomer || !this.selectedSystem) return [];
            const foundCustomer = this.customers.find(c => c.id === this.selectedCustomer);
            if (!foundCustomer) return [];

            const foundSystem = foundCustomer.systems.find(s => s.id === this.selectedSystem);
            const sorted = foundSystem?.modelInfoList.sort((a, b) => {
                return b.id - a.id;
            });
            return sorted || [];
        },
        currentSystemTimezone () {
            if (!this.selectedCustomer || !this.selectedSystem) return 'UTC';
            const foundCustomer = this.customers.find(c => c.id === this.selectedCustomer);
            if (!foundCustomer) return 'UTC';

            const foundSystem = foundCustomer.systems.find(s => s.id === this.selectedSystem);
            return foundSystem?.timezone || 'UTC';
        },
        browserTimezone () {
            return DateTime.local().zoneName;
        }
    },
    watch: {
        selectedCustomer (newVal) {
            if (this.filteredSystems.length > 0) {
                this.selectedSystem = this.filteredSystems[0].id;
            } else {
                this.selectedSystem = null;
            }
        },
        selectedSystem (newVal) {
            // Force update when system changes to ensure timezone is refreshed
            this.$forceUpdate();
        }

    },
    mounted () {
        this.getData();

    },
};
</script>
